module.exports = __webpack_public_path__ + "static/media/tux.2710825d.png";